module.exports = __webpack_public_path__ + "static/ppt1-67cf39cbf19790480b8f314980ff8354.png";